// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Teaser as t } from '@xprog/prensa/types'

export const TeaserEditorialSm: t.TeaserProps = {
  css: {
    padding: '$0',
    mb: '$8',
    minHeight: '80px',
    width: '100%',
    '.TeaserImageContainer': {
      backgroundColor: 'transparent',
      maxWidth: 'calc(88px + $3)',
      width: 'auto',
      'img': {
        pr: '$3'
      }
    },
    '.TeaserSubjectText': {
      align: ['column', 'left', 'top'],
      textTransform: 'uppercase',
      fontSize: '14px',
      mb: '$2'
    },
    '.TeaserSubtitleText': {
      align: ['column', 'left', 'top'],
      color: '#4d4d4d',
      fontFamily: '$primary',
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '17px',
      width: '100%'
    },
    '.TeaserSubtitle': {
      align: ['row', 'left', 'middle'],
    },
    '.TeaserTitle': {
      mb: '$2'
    },
    '.TeaserTitleText': {
      align: ['row', 'left', 'middle'],
      color: 'black',
      fontSize: '18px',
      lineHeight: '22px',
      fontWeight: 400,
      letterSpacing: '0.2px',
      width: '100%'
    },
    '.TeaserWrap': {
      minWidth: 'calc(100% - 88px - $3)'
    }
  },
  className: 'TeaserEditorialSm',
  imageDerivative: '1x1',
  imageVariant: 'left',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-datetime',
  titleVariant: 'newstitle-md'
}